<template>
  <div class="toggle-button">
    <input
      id="toggle"
      class="toggle-input"
      type="checkbox"
      :checked="value"
      :key="value"
      @click="click"
      :disabled="disabled"
    />
    <label for="toggle" class="toggle-label"></label>
  </div>
</template>

<script setup>
// プロパティの定義
defineProps({
  value: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// イベントの定義
const emit = defineEmits(['input']);

// クリックメソッドの定義
const click = (e) => {
  emit('input', e.target.checked);
  e.preventDefault();
};
</script>

<style scoped>
.toggle-button {
  position: relative;
  width: 7.5rem;
  height: 3.5rem;
}
.toggle-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
}
.toggle-label {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  position: relative;
  display: inline-block;
  border-radius: 4rem;
  transition: 0.4s;
  box-sizing: border-box;
}
.toggle-label:after {
  content: '';
  position: absolute;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  left: 0;
  top: 0;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
  transition: 0.4s;
}
.toggle-input:checked + .toggle-label {
  background-color: #4bd865;
}
.toggle-input:checked + .toggle-label:after {
  left: 4rem;
}
</style>
